import React from 'react';
import Dots from './Dots';
import links from '../../data/links.json';
import SocialIcons from '../../components/Footer/Social';
import svg from './404.svg';
import FreshWorks from '../../components/Common/Freshworks';

const NotFound404 = () => {
  return (
    <div className="py-24 bg-gray-50 sm:px-6 lg:px-8">
      <Dots />
      <div className="sm:mx-auto sm:w-full sm:max-w-xl px-3">
        <div className="mx-auto flex items-center justify-center h-16 w-16 ">
          <img src={svg} alt="404 Not found" />
        </div>
        <h2 className="mt-8 text-2xl font-bold leading-9 text-center text-gray-700 sm:text-3xl tracking-tight">
          Page Not Found
        </h2>
        <p className="mt-6 text-lg text-center text-gray-600 leading-10">
          We’re sorry, we seem to have lost this page. <br />
          Please&nbsp;
          <FreshWorks className="text-indigo-600" title="contact support" />
          &nbsp;or send a tweet to{' '}
          <a
            href={links.TWITTER}
            target="_blank"
            rel="noopener noreferrer"
            className="text-indigo-600 font-mono tracking-tighter"
          >
            @labnol
          </a>{' '}
          for assistance.
        </p>
        <div className="mt-6 w-32 mx-auto">
          <SocialIcons />
        </div>
      </div>
    </div>
  );
};

export default NotFound404;
